import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 opacity-5" }
const _hoisted_2 = { class: "mt-4" }

import {localeDateTimeString} from "~/core-ui/ts/CoreUiHelpersMixin";
import {__} from "~/ts/library/Translate";
import OperatorApplicationClientTargetReasonOpenApiModel = OperatorApplicationApi.OperatorApplicationClientTargetReasonOpenApiModel;


const __default__ = {
    name: "SideMenuTargetReasonsTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    reason: {}
  },
  setup(__props: any) {


let props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, _toDisplayString(__props.reason.reason), 1),
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(localeDateTimeString)(__props.reason.dateTime)) + " ", 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)("Кликните, чтобы удалить")), 1)
    ])
  ], 64))
}
}

})